module.exports = __webpack_public_path__ + "img/WN.fb392f50.png";